module.exports = __webpack_public_path__ + "static/media/wechat.6e14cbfa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/wechat.jpg
// module id = 406
// module chunks = 0